/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import error from '../../../assets/ccsearch/error404.png';

/**
 * Mapping of error codes and the content and styling attributes that apply to those error codes.
 */
export const ERROR_STATE_MAP = {
	404: {
		icon: error,
		title: 'app.errorpage.e400.title',
		detail: 'app.errorpage.e400.detail',
		detailMessageClass: 'error-detail-message-4xx',
	},
	500: {
		icon: error,
		title: 'app.errorpage.e500.title',
		detail: 'app.errorpage.e500.detail',
		detailMessageClass: 'error-detail-message-5xx',
	},
	504: {
		icon: error,
		title: 'app.errorpage.e504.title',
		detail: 'app.errorpage.e504.detail',
		detailMessageClass: 'error-detail-message-5xx',
	},
};
